/*
 * Created on Sat Jun 19 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useState } from 'react';
import { Tabs as UITabs, Tab } from '@material-ui/core';

export function Tabs({ activeTab }) {
    const [hoveredTab, setHoveredTab] = useState(activeTab);

    return (
        <UITabs
            id="terms"
            className="nav"
            value={hoveredTab}
            onMouseOut={() => setHoveredTab(activeTab)}
            TabIndicatorProps={{ children: <span /> }}
        >
            <Tab className="nav-link pink-text"
                href='/here/terms'
                label='terms of use'
                onMouseOver={() => setHoveredTab(0)}
                disableRipple
            >
            </Tab>
            <Tab className="nav-link pink-text"
                href='/here/privacy'
                label='privacy policy'
                onMouseOver={() => setHoveredTab(1)}
                disableRipple
                icon={<div className="nav-line"></div>}
            >
            </Tab>
        </UITabs>
    )
}